import { getMomentTz } from "@dexteel/mesf-core";
import { DatePicker } from "@mui/x-date-pickers";
import React from "react";

type Props = {
	value: Date;
	onChange: (date: Date | null) => void;
};

const moment = getMomentTz();

export const EndFilter: React.FC<Props> = ({ value, onChange }) => {
	return (
		<DatePicker
			label="End"
			format="MM/DD/YYYY"
			value={moment(value)}
			onChange={(newValue) => {
				onChange(newValue ? newValue.toDate() : null);
			}}
			slotProps={{
				textField: {
					variant: "outlined",
					size: "small",
					inputProps: { style: { width: "110px", padding: 10 } },
				},
			}}
		/>
	);
};
